import React from 'react';
import {
    ToggleButton,
    ToggleButtonGroup,
    toggleButtonGroupClasses
} from '@mui/material';
import { styled } from '@mui/system';
const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme, fullWidth }) => ({
    display: 'flex',
    borderRadius: '24px',
    backgroundColor: theme.palette.background.default,
    border: `1px solid ${theme.palette.text.light}`,
    boxShadow: '0px 1px 2px 0px #1018280D',
    padding: '6px 8px',
    height: '48px',
    width: fullWidth ? '100%' : 'auto',
    [`& .${toggleButtonGroupClasses.grouped}`]: {
        "margin": 0,
        "border": 'none',
        "borderRadius": '24px',
        "flex": fullWidth ? 1 : 'unset',
        '&:not(:first-of-type)': {
            // "marginLeft": '4px',
            padding: '8px 18px',
            borderTopLeftRadius: '18px',
            borderBottomLeftRadius: '18px',
            borderTopRightRadius: '18px',
            borderBottomRightRadius: '18px'
        },
        '&:not(:last-of-type)': {
            marginRight: '4px',
            padding: '8px 18px',
            borderTopLeftRadius: '18px',
            borderBottomLeftRadius: '18px',
            borderTopRightRadius: '18px',
            borderBottomRightRadius: '18px'
        },
        [`&.${toggleButtonGroupClasses.disabled}`]: {
            border: 'none'
        }
    }
}));

// Styled ToggleButton
const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
    "borderRadius": '24px',
    "color": theme.palette.text.default,
    '&.Mui-selected': {
        "backgroundColor": theme.palette.primary.main,
        "color": theme.palette.primary.lightest,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
            color: theme.palette.primary.lightest
        }
    },
    '&:hover': {
        backgroundColor: theme.palette.background.neutral,
        color: theme.palette.primary.main
    }
}));

const ToggleSwitch = ({ options = [], value, onChange, fullWidth }) => {
    return (
        <StyledToggleButtonGroup
            value={value}
            exclusive
            onChange={(event, newValue) => onChange(newValue)}
            aria-label="text alignment"
            fullWidth={fullWidth}
        >
            {options.map((option, index) => (
                <StyledToggleButton
                    key={index}
                    value={option.value}
                    aria-label={option.label}
                >
                    {option.label}
                </StyledToggleButton>
            ))}
        </StyledToggleButtonGroup>
    );
};

export default ToggleSwitch;
